export default __webpack_public_path__ + "static/media/ts-6-4.bf1d47e6.svg";